<cdx-grid [options]="customOptions">
  <div navbar class="navbar">
    <button style="z-index: 1" class="cdx-button cdx-button--icon cdx-button--lg" (click)="showConfirmWindow()">
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far', 'arrow-left']"></fa-icon>
    </button>
    <h3>{{ "envelope.navbar.backhome" | translate }}</h3>

    <div class="define-signatures" *ngIf="this.newEnvelopeService.getCurrentStep() === newEnvelopeSteps.Signatures">
      <h3 class="primary font-weight-bolder">
        {{ "envelope.navbar.set-location" | translate }}
      </h3>
    </div>

    <div class="edit-mode" *ngIf="this.newEnvelopeService.getCurrentStep() === newEnvelopeSteps.Signatures"
      id="edit-mode">
      <button class="cdx-button cdx-button--icon cdx-button--lg mr-1 border-less" (click)="asideRight()">
        <fa-icon class="fa-fw cdx-button__icon" [icon]="['far', 'bars']" [ngbTooltip]="signatureSideRightToolTip"
          data-placement="left-top" size="sm"></fa-icon>
      </button>
    </div>
  </div>

  <div content>
    <div [ngSwitch]="this.newEnvelopeService.getCurrentStep()" class="main-envelope__container">
      <div *ngSwitchCase="newEnvelopeSteps.Upload">
        <app-new-envelope></app-new-envelope>
      </div>
      <div *ngSwitchCase="newEnvelopeSteps.Settings">
        <envelope-settings></envelope-settings>
      </div>
      <div *ngSwitchCase="newEnvelopeSteps.Signatory">
        <envelope-signatory></envelope-signatory>
      </div>
      <div *ngSwitchCase="newEnvelopeSteps.Signatures">
        <app-envelope-signatures></app-envelope-signatures>
      </div>
      <div *ngSwitchCase="newEnvelopeSteps.Review">
        <envelope-review></envelope-review>
      </div>
    </div>

    <footer class="footer fixed-bottom bg-gray pt-3 pt-sm-0">
      <div class="container-fluid">
        <div class="row align-items-center">
          <div *ngIf="this.newEnvelopeService.getCurrentStep() ===  newEnvelopeSteps.Signatures && !isMobile"
            class="col-md-3 footer__tutorial d-flex justify-content-center justify-content-md-start">
            <button class="cdx-button cdx-button--tertiary" (click)="onTutorialClick()">
              <span class="cdx-button__text">{{ 'new-envelope.step.tutorial.placeholder' | translate | uppercase }}</span>
            </button>
          </div>
          <div class="col-12">
            <div class="row align-items-center justify-content-center">
              <div [class]="isMobile ? 'col-md-8' : 'col-md-5'">
                <cdx-stepper-horizontal [options]="steps"></cdx-stepper-horizontal>
              </div>
            </div>
          </div>
          <div class="col-md-3 footer__buttons d-flex justify-content-center justify-content-md-end">
            <button class="cdx-button cdx-button--secondary cdx-button--outline ml-0" [id]="addIdButtonsBack()"
              [hidden]="this.newEnvelopeService.getCurrentStep() === newEnvelopeSteps.Upload" (click)="stepBack()">
              <span class="cdx-button__text">{{ "Back" | translate }}</span>
            </button>
            <button class="cdx-button cdx-button--primary ml-2" [id]="addIdButtonsNext()"
              [hidden]="this.newEnvelopeService.getCurrentStep() === newEnvelopeSteps.Review && !isValidStepInfo()"
              (click)="stepNext()" [disabled]="!isValidStepInfo()">
              <span class="cdx-button__text">{{(newEnvelopeService.getCurrentStep() !== newEnvelopeSteps.Review?
                "Next":"Send") | translate}}</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  </div>

  <ng-container left>
    <app-envelope-sidebar-custom-fields [signatories]="listSignatories">
    </app-envelope-sidebar-custom-fields>
  </ng-container>

  <ng-container right>
    <app-envelope-sidebar-detail (closeAside)="asideRight()">
    </app-envelope-sidebar-detail>
  </ng-container>
</cdx-grid>

<ng-template #confirmBackModal>
  <app-confirm-modal [HeaderText]="'envelope.confirm-back-modal.headerText'"
    [QuestionText]="'envelope.confirm-back-modal.questionText'"
    [MessageText]="'envelope.confirm-back-modal.messageText'" (closeModalClick)="confirmModalClose()"
    (confirmModalClick)="confirmModalYesClick()" [ButtonConfirmText]="'yes'" [ButtonCancelText]="'no'"
    [IsApprovalConfirm]=false>
  </app-confirm-modal>
</ng-template>

<cdx-onboarding-tour
  onboardingId="onboardingSignPosition"
  *ngIf="showOnBoardingPosition"
  [options]="onBoardingSignPosition"
  (onCloseTour)="handleClosePositionTour($event)">
</cdx-onboarding-tour>

<ng-template #modalExcludeStamp let-modal>
  <div class="modal-header">
    <div class="icon-title">
      <fa-icon class="ml-1 mt-1 mr-3 icon-left fa-icon-color--danger" size="2x" fa-fw="true"
        [icon]="['fad','exclamation-circle']">
      </fa-icon>
      <h3 class="modal-title" id="modal-basic-title">
        {{ 'modalExcludeStamp.header' | translate }}
      </h3>
    </div>
    <button class="cdx-button__close" type="button" aria-label="Close" (click)="modal.dismiss()">
      <fa-icon [icon]="['far','times']" fa-fw="true"></fa-icon>
    </button>
  </div>
  <div class="modal-body">
    <p> {{ 'modalExcludeStamp.body' | translate }}</p>
    <p> {{ 'modalExcludeStamp.body-2' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button class="cdx-button cdx-button--ternary mr-2" (click)="modal.close()">
      <span class="cdx-button__text"> {{ 'modalExcludeStamp.btnCancel' | translate }}</span>
    </button>
    <button class="cdx-button cdx-button--primary cdx-button--danger" (click)="excludeSingleStamp()">
      <span class="cdx-button__text">{{ 'modalExcludeStamp.btnExclude' | translate }}</span>
    </button>
  </div>
</ng-template>

<ng-template #modalExcludeRubric let-modal>
  <div class="modal-header">
    <div class="icon-title">
      <fa-icon class="ml-1 mt-1 mr-3 icon-left fa-icon-color--danger" size="2x" fa-fw="true"
        [icon]="['fad','exclamation-circle']">
      </fa-icon>
      <h3 class="modal-title" id="modal-basic-title">
        {{ 'modalExcludeRubric.header' | translate }}
      </h3>
    </div>
    <button class="cdx-button__close" type="button" aria-label="Close" (click)="modal.dismiss()">
      <fa-icon [icon]="['far','times']" fa-fw="true"></fa-icon>
    </button>
  </div>
  <div class="modal-body">
    <p> {{ 'modalExcludeRubric.body' | translate }}</p>
    <p> {{ 'modalExcludeRubric.body-2' | translate }}</p>
  </div>
  <div class="modal-footer">
    <button class="cdx-button cdx-button--ternary mr-2" (click)="modal.close()">
      <span class="cdx-button__text"> {{ 'modalExcludeRubric.btnCancel' | translate }}</span>
    </button>
    <button class="cdx-button cdx-button--primary cdx-button--danger" (click)="excludeSingleRubric()">
      <span class="cdx-button__text">{{ 'modalExcludeRubric.btnExclude' | translate }}</span>
    </button>
  </div>
</ng-template>

<ng-template #modalEditCustomField let-modal>
  <app-envelope-sidebar-edit-custom-field
    [customField]="customFieldSelected"
    (closeModal)="closeEditCustomFieldModal()"
    (deleteModal)="openExcludeCustomFieldModal()"
    (confirmModal)="saveCustomField($event)">
  </app-envelope-sidebar-edit-custom-field>
</ng-template>

<ng-template #modalExcludeCustomField let-modal>
  <div class="modal-header" style="padding: 16px !important;">
    <div class="icon-title">
      <fa-icon class="ml-1 mt-1 mr-3 icon-left fa-icon-color--danger" size="2x" fa-fw="true"
        [icon]="['fad','exclamation-triangle']">
      </fa-icon>
      <h3 class="modal-title" id="modal-basic-title">
        {{ 'signatureSideSelli.modalExcludeCustomField.header' | translate }}
      </h3>
    </div>
    <button class="cdx-button__close" type="button" aria-label="Close" (click)="modal.dismiss()">
      <fa-icon [icon]="['far','times']" fa-fw="true"></fa-icon>
    </button>
  </div>
  <div class="modal-body">
    <p style="font-size: 14px !important;"> {{ 'signatureSideSelli.modalExcludeCustomField.body' | translate }}</p>
    <p style="font-size: 14px !important;"> {{ 'signatureSideSelli.modalExcludeCustomField.body-2' | translate }}</p>
  </div>
  <div class="modal-footer" style="padding: 16px !important;">
    <button class="cdx-button cdx-button--secondary cdx-button--outline mr-2" (click)="modal.close()">
      <span class="cdx-button__text"> {{ 'signatureSideSelli.modalExcludeCustomField.btnCancel' | translate }}</span>
    </button>
    <button class="cdx-button cdx-button--primary cdx-button--danger" (click)="excludeSingleCustomField()">
      <span class="cdx-button__text">{{ 'signatureSideSelli.modalExcludeCustomField.btnExclude' | translate }}</span>
    </button>
  </div>
</ng-template>

<cdx-onboarding onboardingId="mobileDesktopView" [options]="mobileDesktop" [(showOnboarding)]="showOnboardingMobile" (primaryBtnClick)="primaryBtnClickedMobile()"></cdx-onboarding>
